import type { Notification as AbstractNotification } from '@svoi-ui/interfaces/notification'
import { uuid } from '~/shared/utils/helpers'
import type { Serializable } from '~/shared/interfaces/serializable'

export default class Notification implements AbstractNotification, Serializable {
  id: string
  title: string
  text?: string
  componentContent?: AbstractNotification['componentContent']
  type?: AbstractNotification['type']
  collapse?: boolean
  timeout?: number
  buttons?: AbstractNotification['buttons']

  static constructorName = 'Notification'

  constructor(params: Omit<AbstractNotification, 'id'>) {
    this.id = uuid()
    this.title = params.title
    this.text = params.text
    this.type = params.type
    this.collapse = params.collapse
    this.buttons = params.buttons
    this.componentContent = params.componentContent
    this.timeout = 'timeout' in params ? params.timeout : 5000
  }

  serialize() {
    return {
      constructorName: Notification.constructorName,
      data: {
        title: this.title,
        text: this.text,
        type: this.type,
        collapse: this.collapse,
        buttons: this.buttons,
        componentContent: this.componentContent,
      },
    }
  }
}
